import { Button, ButtonProps } from "@mui/material";
import { styled } from "@mui/material/styles";

import { useNextTranslation } from "../../../hooks";

const CheckAvailabilityButton = styled(Button)({
    alignSelf: "center",
});

type ExternalWidgetAvailabilityProps = ButtonProps;

export const ExternalWidgetAvailability = (props: ExternalWidgetAvailabilityProps) => {
    const [t] = useNextTranslation("availability");

    return (
        <>
            <CheckAvailabilityButton variant="contained" color="primary" disableElevation={true} {...props}>
                {t("action.checkAvailability")}
            </CheckAvailabilityButton>
        </>
    );
};
